module.exports = __webpack_public_path__ + "static/img/naturalCircle4h.9cab7be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle4h.svg
// module id = yrAg
// module chunks = 1